module.exports = __webpack_public_path__ + "img/imgCYYQ(2).f6674939.png";